// extracted by mini-css-extract-plugin
export default {"play":"GalleryItem_play__4lhdj","play__icon":"GalleryItem_play__icon__g0HAj"};